import * as microsoftTeams from "@microsoft/teams-js";

export default function showConsentDialog(
  onSuccess?: (result: string) => void,
  onFailure?: (reason: string) => void
) {
  microsoftTeams.authentication
    .authenticate({
      url: window.location.origin + "/auth/start",
      width: 600,
      height: 535,
    })
    .then((result: string) => {
      console.log("Consent result: ", result);
      if (onSuccess) onSuccess(result);
    })
    .catch((reason: string) => {
      console.error("Consent failed: ", reason);
      if (onFailure) onFailure(reason);
    });
}
